import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=482a46fd&scoped=true"
import script from "./Turntable.vue?vue&type=script&lang=js"
export * from "./Turntable.vue?vue&type=script&lang=js"
import style0 from "./Turntable.vue?vue&type=style&index=0&id=482a46fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a46fd",
  null
  
)

export default component.exports